<template>
    <div class="mt-5">
        <vs-divider>
            <div class="flex">
                <vs-button icon-pack="feather" v-if="accion == 0" icon="icon-plus" class="mr-2 mt-2" color="#56D5DB"  @click="accion = 1">Añadir opción</vs-button>
                <vs-button icon-pack="feather" v-if="accion == 1 || accion == 2" icon="icon-corner-down-left" class="p-2 mt-2"  @click="accion = 0">Regresar</vs-button>
            </div>
        </vs-divider>
        <div v-if="accion == 0">
            <vs-table :data="arregloOpciones" stripe class="mt-4" pagination max-items="5" search>
                <template slot="header">
                    <vs-chip>Cantidad: {{ arregloOpciones.length }}</vs-chip>
                </template>
                <template slot="thead">
                    <vs-th v-if="tipo == 5">{{ datos.columna1 }}</vs-th>
                    <vs-th v-if="tipo == 5">{{ datos.columna2 }}</vs-th>
                    <vs-th v-if="tipo != 5">Detalle</vs-th>
                    <vs-th v-if="tipo != 5">Imagen</vs-th>
                    <vs-th>Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <div v-if="tipo == 5">
                                <p><b>{{ indextr + 1 }}.</b> {{ tr.respuesta }}</p>
                            </div>
                            <div v-else>
                                <b>Descripción:</b>
                                <p>{{ tr.respuesta }}</p>
                                <vs-chip v-if="tr.opcion == 'true'"  color="success" transparent>Correcta</vs-chip>
                                <vs-chip v-if="tr.opcion == 'false'" color="danger"  transparent>Incorrecta</vs-chip>
                                <vs-chip v-if="tr.opcion == null" color="warning" transparent>SIN OPCION</vs-chip>
                            </div>
                        </vs-td>
                        <vs-th v-if="tipo == 5">
                            {{ String.fromCharCode(97 + indextr) }}) {{ tr.caracteristica }}
                        </vs-th>
                        <vs-td v-if="tipo != 5">
                            <img width="250" :src="$data_book+'archivos/'+'opcion_preguntas'+'/'+tr.url" alt="Desert" v-if="tr.url != null" />
                        </vs-td>
                        <vs-td>
                            <div class="flex">
                                <vs-button class="inline m-3" size="small" color="warning" @click="accion = 2;ObjectSelectedOpcion = tr;" icon="edit" type="filled"></vs-button>
                                <vs-button class="inline m-3" size="small" color="danger" icon="delete" type="filled" @click="ObjectSelectedOpcion = tr;accion=3;"></vs-button>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <!--crear editar-->
        <div v-if="accion == 1 || accion == 2">
            <vs-divider v-if="accion == 1">Agregar Opción</vs-divider>
            <vs-divider v-if="accion == 2">Editar Opción</vs-divider>
            <!--agregar-->
            <CrearOpcionVue :datos="datos" :tipoSelect="tipoSelect" :tipo="tipo" :ObjectSelectedOpcion="Object(ObjectSelectedOpcion)" v-if="accion == 1" :idOpcion="Number(0)" @changeHandle="changeHandle"/>
            <!--editar-->
            <CrearOpcionVue :datos="datos" :tipoSelect="tipoSelect" :tipo="tipo" :ObjectSelectedOpcion="Object(ObjectSelectedOpcion)" v-if="accion == 2" :idOpcion="Number(ObjectSelectedOpcion.id)" @changeHandle="changeHandle"/>
        </div>
        <!--eliminar-->
        <div v-if="accion == 3">
            <ConfirmAccionVue @changeConfirm="changeConfirm" :otroValor="Number('1')" :title="'Estas seguro de eliminar la opción?'" :subtitle="'Si, deseo eliminar'"/>
        </div>
    </div>
</template>
<script>
const CrearOpcionVue = () => import('./CrearOpcion.vue')
import ConfirmAccionVue from '@/views/admin/reutilizable/Confirm/ConfirmAccion.vue';
import GeneralMixin from '../../../../mixins/GeneralMixin';
export default {
    components: {
        CrearOpcionVue,
        ConfirmAccionVue
    },
    mixins: [GeneralMixin],
    data() {
      return{
        arregloOpciones:[],
        accion:0,
        ObjectSelectedOpcion:null,
        carpeta:'opcion_preguntas',
      }  
    },
    props: {   
        datos: {
            type: Object,
            required: true,
            default: () => {}
        },
        tipo:{
            type:Number,
            required:true,
            default:0
        },
        tipoSelect:{
            type:Number,
            default:0
        },
    },
    mounted(){
        let me = this;
        if(me.datos.id){
            me.f_get_opciones_x_pregunta()
        }
    },
    methods:{
        changeHandle(){
            let me = this;
            me.f_get_opciones_x_pregunta();
            me.$emit('change_pregunta_editada', me.datos.id);
        },
        changeConfirm(e){
            let me = this;
            if(e == 0) { me.accion = 0; }
            if(e == 1) { me.f_delete_opcion(); }
        },
        f_delete_opcion(){
            let me = this;
            let formData = new FormData();
            formData.append('id',                me.ObjectSelectedOpcion.id)
            formData.append('ruta',              me.carpeta)
            //save en tabla
            //nombre modelo
            formData.append('nombreM',           "PreguntaOpcion")
            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            me.$vs.loading();
            this.$http.post(this.$data_url + 'api/quitarArchivoIndividual', formData,config)
            .then((result) => {
                me.$vs.loading.close();
                me.f_notificaciones("Se elimino correctamente", "warning");
                me.accion = 0;
                me.f_get_opciones_x_pregunta();
                me.$emit('change_pregunta_editada', 0);
            }).catch((err) => {
                me.$vs.loading.close();
                me.$vs.notify({
                    title: 'Error',
                    text: 'Error al eliminar la opción',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
            });
        },
        f_get_opciones_x_pregunta() {
            let me = this;
            me.arregloOpciones = [];
            me.accion = 0;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'get_opciones_pregunta/' + me.datos.id)
                .then((res) => {
                    console.log(res.data)
                    me.arregloOpciones = res.data;
                    //actualizar estado pregunta
                    if(me.arregloOpciones.length > 0){
                        me.updatePregunta(1)
                    }else{
                        me.updatePregunta(2)
                    }
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();
                })
        },
        updatePregunta(est){
            let me = this;
            let formData = new FormData();
            formData.append('id',                me.datos.id)
            formData.append('campo1',            "estado")
            formData.append('valor1',            est)
            formData.append('updateCampos',      1)    
            me.$http.post(this.$server_url + 'preguntasMetodosPost', formData)
            .then((result) => {
                me.$emit('change_pregunta_editada', me.datos.id);
            }).catch((err) => {
            });
        },
    }
}
</script>